export const bulletPoints = [
    "File size should not exceed 25mb.",
    "Max 5 files can be attached.",
    "Allowed file formats: .jpg, .jpeg, .png, .xlsx, .xls, .csv, .txt, .docx, .pdf",
    "Total file(s) size should not exceed 25 mb",
];

export const csvFilePoints = [
    "File size should not exceed 2mb.",
    "File format should be '.xlsx or .xls",
    "Csv file should contain one 'emails' column",
];
